"use strict";

var _classCallCheck = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;

var context_1 = require("./compile/context");

exports.KeywordCxt = context_1.default;

var codegen_1 = require("./compile/codegen");

Object.defineProperty(exports, "_", {
  enumerable: true,
  get: function get() {
    return codegen_1._;
  }
});
Object.defineProperty(exports, "str", {
  enumerable: true,
  get: function get() {
    return codegen_1.str;
  }
});
Object.defineProperty(exports, "stringify", {
  enumerable: true,
  get: function get() {
    return codegen_1.stringify;
  }
});
Object.defineProperty(exports, "nil", {
  enumerable: true,
  get: function get() {
    return codegen_1.nil;
  }
});
Object.defineProperty(exports, "Name", {
  enumerable: true,
  get: function get() {
    return codegen_1.Name;
  }
});
Object.defineProperty(exports, "CodeGen", {
  enumerable: true,
  get: function get() {
    return codegen_1.CodeGen;
  }
});

var core_1 = require("./core");

var draft7_1 = require("./vocabularies/draft7");

var draft7MetaSchema = require("./refs/json-schema-draft-07.json");

var META_SUPPORT_DATA = ["/properties"];
var META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";

var Ajv = /*#__PURE__*/function (_core_1$default) {
  _inherits(Ajv, _core_1$default);

  var _super = _createSuper(Ajv);

  function Ajv() {
    _classCallCheck(this, Ajv);

    return _super.apply(this, arguments);
  }

  _createClass(Ajv, [{
    key: "_addVocabularies",
    value: function _addVocabularies() {
      var _this = this;

      _get(_getPrototypeOf(Ajv.prototype), "_addVocabularies", this).call(this);

      draft7_1.default.forEach(function (v) {
        return _this.addVocabulary(v);
      });
    }
  }, {
    key: "_addDefaultMetaSchema",
    value: function _addDefaultMetaSchema() {
      _get(_getPrototypeOf(Ajv.prototype), "_addDefaultMetaSchema", this).call(this);

      if (!this.opts.meta) return;
      var metaSchema = this.opts.$data ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA) : draft7MetaSchema;
      this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
      this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
  }, {
    key: "defaultMeta",
    value: function defaultMeta() {
      return this.opts.defaultMeta = _get(_getPrototypeOf(Ajv.prototype), "defaultMeta", this).call(this) || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
  }]);

  return Ajv;
}(core_1.default);

exports.default = Ajv;